import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCartItem } from "states/cart/cart.models";
import { formatMoney } from "../../shared/plugins/string-helper";
interface InfoProps {
  orderItems: ShoppingCartItem[];
  subTotal: number;
  shippingFee: number;
  discount: number;
  total: number;
}
export const InfoComponent = (props: InfoProps) => {
  const { orderItems, subTotal, shippingFee, discount,  total } = props;
  return (
    <div className="info-container-inner">
      <div className="head p-bot-2 ">
        <span className="text-bold text-black">Thông tin đơn hàng</span>
        <Link to="/cart" className="btn btn-cart">
          Chỉnh sửa
        </Link>
      </div>
      <div className="cart-item-container">
        {orderItems &&
          orderItems.map((orderItem) => (
            <div className="item-cart">
              <div className="ava">
                <div className="img-container">
                  <img src={orderItem.skuImage} alt=""/>
                </div>
              </div>
              <div className="name">
                {orderItem.skuName}
              </div>
              <div className="quantity">x{orderItem.quantity}</div>
              <div className="price">
                <span className="text-bold">
                  {formatMoney(orderItem.price)}
                </span>
              </div>
            </div>
          ))}
      </div>
      <div className="summary-container">
        <div className="item-summary m-bot-1">
          <h6 className="h5 name">Tạm tính:</h6>
          <h6 className="h5 price">
            {formatMoney(subTotal)}
          </h6>
        </div>
        <div className="item-summary m-bot-1">
          <h6 className="h5 name">Phí giao hàng:</h6>
          <h6 className="h5 price">
            {formatMoney(shippingFee)}
          </h6>
        </div>
        <div className="item-summary m-bot-1">
          <h6 className="h5 name">Giảm giá:</h6>
          <h6 className="h5 price">
            {formatMoney(discount)}
          </h6>
        </div>
        <div className="total item-summary m-top-1 ">
          <h6 className="h5 name">Thành tiền:</h6>
          <h6 className="h5 price">{formatMoney(total)}</h6>
        </div>
      </div>
    </div>
  );
};
